module.exports = __webpack_public_path__ + "media/images/amenities_icons/heater-3a0b14b2619cf0a22b5a3cab96227675.svg";